import api from './api';

export const getWebhookActions = (page, params) => {
  return api.get('admin/WebhookAction', { params: { page: page, limit: 10, order: 'createdAt', direction: 'DESC', ...params } });
};

export const getWebhookActionsBySearch = (searchItem, search) => {
  return api.get(`admin/WebhookAction?searchItem=${searchItem}&search=${search}`);
};

export const getWebhookByOrder = (item, direction) => {
  return api.get(`admin/WebhookAction?order=${item}&direction=${direction}`);
};

export const getWebhookByUniqueId = uniqueId => {
  return api.get(`admin/webhook/${uniqueId}`);
};
